import { alpha, Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import Tooltip from './Tooltip';

interface BoxCardProps {
    children?: ReactNode;
    tooltip?: ReactNode;
    small?: boolean;
    variant?: 'primary' | 'success' | 'warning' | 'neutral';
}

export const BoxCard: FC<BoxCardProps> = ({
    children,
    tooltip,
    small = false,
    variant = 'primary',
}) => {
    const content = (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            minWidth={small ? '60px' : '88px'}
            height={small ? '34px' : '46px'}
            position="relative"
            px={1}
            sx={(theme) => ({
                borderRadius: '8px',
                background: `linear-gradient(
          180deg,
          ${theme.palette.primary.light} 0%,
          ${theme.palette.primary.main} 100%
        )`,
                boxShadow: `
          0 4px 12px rgba(0,0,0,0.18),
          inset 0 1px 0 rgba(255,255,255,0.25)
        `,
                transition: 'all 0.2s ease',
                cursor: 'default',

                '&:hover': {
                    transform: 'translateY(-1px)',
                    boxShadow: '0 6px 16px rgba(0,0,0,0.22)',
                },
            })}
        >
            {children}
        </Box >
    );

    return tooltip ? (
        <Tooltip title={tooltip} arrow placement="bottom">
            <Box display="inline-flex">{content}</Box>
        </Tooltip>
    ) : (
        content
    );
};
